export default function Access() {
  const infoItems = [
    {
      icon: 'ri-map-pin-line',
      title: '住所',
      content: '〒253-0055 神奈川県茅ヶ崎市中海岸X丁目'
    },
    {
      icon: 'ri-time-line',
      title: '営業時間',
      content: '11:00 - 18:00 (L.O. 17:30)'
    },
    {
      icon: 'ri-calendar-close-line',
      title: '定休日',
      content: '毎週火曜日'
    },
    {
      icon: 'ri-phone-line',
      title: '電話',
      content: '0467-XX-XXXX'
    }
  ];

  const notices = [
    {
      icon: 'ri-paw-print-line',
      text: 'テラス席のみペット同伴可'
    },
    {
      icon: 'ri-user-forbid-line',
      text: '予約不可（団体のみ要予約）'
    },
    {
      icon: 'ri-parking-line',
      text: '専用駐車場5台完備'
    },
    {
      icon: 'ri-wifi-line',
      text: 'Free Wi-Fi完備'
    }
  ];

  return (
    <section id="access" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            ACCESS &amp; HOURS
          </h3>
          <div className="w-24 h-1 bg-blue-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* Info Cards */}
          <div className="space-y-6">
            {infoItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg p-6 flex items-start hover:shadow-xl transition-shadow"
              >
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${item.icon} text-2xl text-blue-600`}></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">
                    {item.title}
                  </h4>
                  <p className="text-gray-600">{item.content}</p>
                </div>
              </div>
            ))}

            {/* Notices */}
            <div className="bg-blue-600 rounded-xl shadow-lg p-6 text-white">
              <h4 className="text-xl font-bold mb-4 flex items-center">
                <i className="ri-information-line text-2xl mr-2"></i>
                ご来店の際の注意事項
              </h4>
              <div className="space-y-3">
                {notices.map((notice, index) => (
                  <div key={index} className="flex items-center">
                    <i className={`${notice.icon} text-xl mr-3`}></i>
                    <span>{notice.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full min-h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6159.556831333276!2d139.40192150373272!3d35.321359923101646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601852815e6f92ff%3A0x78382d20c14abcd4!2z44CSMjUzLTAwNTUg56We5aWI5bed55yM6IKF44O25bSO5biC5Lit5rW35bK4!5e0!3m2!1sja!2sjp!4v1764147823060!5m2!1sja!2sjp"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '500px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="WAVE RIDER Location"
            ></iframe>
          </div>
        </div>

        {/* Access Guide */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            アクセス方法
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex items-start">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-train-line text-2xl text-green-600"></i>
              </div>
              <div>
                <h5 className="text-lg font-bold text-gray-900 mb-2">電車でお越しの方</h5>
                <p className="text-gray-600 leading-relaxed">
                  JR東海道線「茅ヶ崎駅」南口より徒歩15分<br />
                  または南口バス乗り場より「海岸方面」行きバスで5分、「中海岸」下車徒歩2分
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                <i className="ri-car-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <h5 className="text-lg font-bold text-gray-900 mb-2">お車でお越しの方</h5>
                <p className="text-gray-600 leading-relaxed">
                  新湘南バイパス「茅ヶ崎海岸IC」より約5分<br />
                  国道134号線沿い、専用駐車場5台完備（満車の場合は近隣のコインパーキングをご利用ください）
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}